import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModelCreds } from 'src/app/_models/modelCreds';
import { CustomerService } from 'src/app/_services/customer.service';
import { PricelistService } from 'src/app/_services/pricelist.service';

@Component({
    selector: 'app-securitycode',
    templateUrl: './securitycode.component.html',
    styleUrls: ['./securitycode.component.css'],
    standalone: false
})
export class SecuritycodeComponent implements OnInit {

  @Output() cancelSecuritycode = new EventEmitter;
  @Input() modelCreds: ModelCreds;
  securitycodeForm: FormGroup;
  validationErrors: string[] = [];
  model: any = {}
  constructor(public customerService: CustomerService, private router: Router, private fb: FormBuilder, private pricelistService: PricelistService) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(){
    this.securitycodeForm = this.fb.group({
      securitycode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],

    })
  }

  login()
  {
    this.model.username = this.modelCreds.username;
    this.model.password = this.modelCreds.password;
    this.model.securitycode = this.securitycodeForm.value.securitycode;
    this.customerService.login(this.model).subscribe(response=>{
      this.pricelistService.hasPromotions().subscribe();
      this.router.navigateByUrl('/pricelist');
    });
    
  }

  cancel(){
    this.cancelSecuritycode.emit(false);
  }

}
